<div class="relative flex flex-col items-center md:justify-center w-full min-h-dvh bg-neutral-50">
  <app-lenguage-switcher class="absolute z-100 top-10 right-10"></app-lenguage-switcher>
  <p-toast key="global" position="top-center"> </p-toast>

  <img
    class="bg"
    src="assets/Images/solpol-bg-2.png"
    class="object-cover hue-rotate-45 saturate-40 w-full h-full absolute bg-slate-500"
  />
  <div
    class="relative z-10 flex flex-col items-center md:rounded-md md:bg-linear-to-br from-teal-300/10 to-cyan-900/50 md:w-100 md:shadow-2xl shadow-neutral-700"
  >
    <div
      *ngIf="LoginStepOne == true && LoginStepTwo == false"
      class="relative z-50 flex flex-col items-center"
    >
      <img
        src="assets/Images/solpol_color.png"
        class="md:w-full md:h-40 md:mt-0 mt-15 w-50 object-contain"
      />
      <div class="flex flex-col w-full justify-center items-center gap-10 p-10">
        <p-floatlabel class="w-full">
          <label for="username">{{ 'login.solpol.text_1' | translate }}</label>
          <input pInputText type="text" [(ngModel)]="username" inputId="username" class="w-full" />
        </p-floatlabel>

        <p-floatlabel class="w-full">
          <p for="password" class="w-full">{{ 'login.solpol.text_2' | translate }}</p>
          <p-password
            class="w-full"
            inputId="password"
            (keyup.enter)="loginOnKeyEnter()"
            [(ngModel)]="password"
            [toggleMask]="true"
            [disabled]="isLogging"
          />
        </p-floatlabel>
      </div>

      <re-captcha *ngIf="skipcatcha==false" [siteKey]="sitekey" (resolved)="onCaptchaResolved($event)">
      </re-captcha>
    </div>
    <p-progress-spinner
      [hidden]="!isLogging"
      strokeWidth="8"
      fill="transparent"
      animationDuration=".5s"
      [style]="{
        width: '50px',
        height: '50px',
        position: 'absolute',
        bottom: '65px',
      }"
    />
    <button
      *ngIf="LoginStepOne == true && LoginStepTwo == false"
      pButton
      (click)="Login2FAStepOne()"
      [disabled]="isLogging"
      type="button"
      [label]="'login.solpol.text_0' | translate"
      class="m-15"
    ></button>

    <p
      *ngIf="LoginStepOne == true && LoginStepTwo == false"
      (click)="goToPasswordRecovery()"
      class="text-slate-200 font-semibold cursor-pointer text-center pb-10"
    >
      ¿Has olvidado tu contraseña?
    </p>

    <div
      *ngIf="LoginStepOne == false && LoginStepTwo == true"
      class="flex flex-col items-center px-5 mt-30 md:mt-0 justify-between gap-10 w-full py-10"
    >
      <p class="text-2xl font-bold">{{ 'login.solpol.text_3' | translate }}</p>

      <p-progress-bar
        [value]="progress"
        [style]="{
          width: '100%',
          height: '30px',
          backgroundColor: 'var(--p-surface-400)',
          color: 'red',
        }"
        showValue="false"
      ></p-progress-bar>
      <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between">
        <input
          id="codeSlot1"
          [(ngModel)]="codeSlot1"
          type="text"
          maxlength="1"
          (input)="moveToNext($event, 'codeSlot1', 'codeSlot2')"
          class="bg-neutral-200 rounded-2xl text-5xl w-12 h-20 text-center border border-neutral-400 focus:bg-(--p-primary-600) focus:text-neutral-100"
        />
        <input
          id="codeSlot2"
          [(ngModel)]="codeSlot2"
          type="text"
          maxlength="1"
          (input)="moveToNext($event, 'codeSlot2', 'codeSlot3')"
          class="bg-neutral-200 rounded-2xl text-5xl w-12 h-20 text-center border border-neutral-400 focus:bg-(--p-primary-600) focus:text-neutral-100"
        />
        <input
          id="codeSlot3"
          [(ngModel)]="codeSlot3"
          type="text"
          maxlength="1"
          (input)="moveToNext($event, 'codeSlot3', 'codeSlot4')"
          class="bg-neutral-200 rounded-2xl text-5xl w-12 h-20 text-center border border-neutral-400 focus:bg-(--p-primary-600) focus:text-neutral-100"
        />
        <input
          id="codeSlot4"
          [(ngModel)]="codeSlot4"
          type="text"
          maxlength="1"
          (input)="moveToNext($event, 'codeSlot4', 'codeSlot5')"
          class="bg-neutral-200 rounded-2xl text-5xl w-12 h-20 text-center border border-neutral-400 focus:bg-(--p-primary-600) focus:text-neutral-100"
        />
        <input
          id="codeSlot5"
          [(ngModel)]="codeSlot5"
          type="text"
          maxlength="1"
          (input)="moveToNext($event, 'codeSlot5', 'codeSlot6')"
          class="bg-neutral-200 rounded-2xl text-5xl w-12 h-20 text-center border border-neutral-400 focus:bg-(--p-primary-600) focus:text-neutral-100"
        />
        <input
          id="codeSlot6"
          [(ngModel)]="codeSlot6"
          type="text"
          maxlength="1"
          (input)="moveToNext($event, 'codeSlot6', null)"
          class="bg-neutral-200 rounded-2xl text-5xl w-12 h-20 text-center border border-neutral-400 focus:bg-(--p-primary-600) focus:text-neutral-100"
        />
      </div>
      <p>{{ 'login.solpol.text_4' | translate }}</p>
      <button
        [disabled]="checkDisabledBtnSendCode()"
        pButton
        (click)="Login2FAStepTwo()"
        type="button"
        [label]="'login.solpol.label_1' | translate"
      ></button>
    </div>
  </div>
</div>

@if (isReloging) {
  <app-relogin-screen #reloginScreen *ngIf="isReloging" [logoUrl]="LogoReloging">
  </app-relogin-screen>
}
